import { render, staticRenderFns } from "./acceptanceLetter.vue?vue&type=template&id=1c5ba6fa&scoped=true&"
import script from "./acceptanceLetter.vue?vue&type=script&lang=js&"
export * from "./acceptanceLetter.vue?vue&type=script&lang=js&"
import style0 from "./acceptanceLetter.vue?vue&type=style&index=0&id=1c5ba6fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ba6fa",
  null
  
)

export default component.exports